import { message } from 'antd';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useCreateInsuranceProductMutation } from '../../../api/mutations/createInsuranceProduct';
import { InsuranceProductKind, type InsuranceProductSettings } from '../../../api/types';
import useHandleError from '../../../utilities/useHandleError';
// eslint-disable-next-line max-len
import { initialValues as createInitialValues } from '../InsuranceProductDetails/InsuranceProductDetailsInnerPage/shared';
import useInsuranceProductValidation from '../InsuranceProductDetails/useInsuranceProductValidation';
import Inner from './Inner';

const AddInsuranceProduct = () => {
    const { t } = useTranslation('insuranceProductDetails');
    const [createInsuranceProduct] = useCreateInsuranceProductMutation();

    const navigate = useNavigate();

    const validate = useInsuranceProductValidation(false);

    const onSubmit = useHandleError<InsuranceProductSettings>(
        async values => {
            // submitting message
            message.loading({
                content: t('insuranceProductDetails:messages.createSubmitting'),
                key: 'primary',
                duration: 0,
            });
            await createInsuranceProduct({
                variables: {
                    kind: InsuranceProductKind.Local,
                    settings: values,
                },
            });

            // inform about success
            message.success({
                content: t('insuranceProductDetails:messages.createSuccessful'),
                key: 'primary',
            });

            navigate(-1);
        },
        [createInsuranceProduct, navigate, t]
    );

    return (
        <Formik initialValues={createInitialValues} onSubmit={onSubmit} validate={validate}>
            {({ handleSubmit }) => <Inner handleSubmit={handleSubmit} />}
        </Formik>
    );
};

export default AddInsuranceProduct;
